import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import fAvatar from "../assets/About_Icon.png";
import mAvatar from "../assets/About_Icon_Male.png";

const ReviewsCarousel = () => {
  return (
    <Carousel
      showArrows={true}
      infiniteLoop={true}
      showThumbs={false}
      showStatus={false}
      autoPlay={true}
      interval={8000}
    >
      <>
        <div className="my-carousel">
          <img className="avatar" src={fAvatar} alt="female avatar image" />
          <h3>Gabriela B.</h3>
          <p>
            "I cherish the two pet portraits I commissioned from Creations by
            Jennifer Kramer. They capture the personality and spirit of both my
            beloved cats and are painted beautifully with expressive realism.
            Jennifer was also kind and professional in her manner."
          </p>
        </div>
      </>
      {/* <>
                <div className="my-carousel">
                    <img className="avatar" src={mAvatar} alt="male avatar image"/>
                    <h3>John Doe</h3>
                    <p>Lorem ipsum</p>
                </div>
            </> */}
      <>
        <div className="my-carousel">
          <img className="avatar" src={fAvatar} alt="female avatar image" />
          <h3>Nancy E.</h3>
          <p>
            "I absolutely loved my pet portrait of my dear 'boyfriend' Cosmos.
            She really captured his personality perfectly!"
          </p>
        </div>
      </>
      {/* <>
                <div className="my-carousel">
                    <img className="avatar" src={mAvatar} alt="male avatar image"/>
                    <h3>John Doe</h3>
                    <p>Lorem ipsum</p>
                </div>
            </> */}
    </Carousel>
  );
};

export default ReviewsCarousel;
